module.exports = "<p-dropdown [options]=\"data\" [filter]=\"true\">\r\n  <template let-row>\r\n    <div class=\"ui-helper-clearfix\" style=\"position: relative;height: 25px;\">\r\n      <!-- <img src=\"assets/showcase/images/demo/car/{{car.label}}.gif\" style=\"width:24px;position:absolute;top:1px;left:5px\" /> -->\r\n      <div style=\"font-size:14px;float:right;margin-top:4px\">{{row.stxt}}</div>\r\n    </div>\r\n  </template>\r\n</p-dropdown>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/select/select.component.html
// module id = 1217
// module chunks = 320